import { KLArticleApiResponse } from 'api/api.types';
import { SourceType } from 'types/enums';
import { Source } from 'types/models';
import { getSourceThemeColor } from 'utils/source.utils';
import { normalizeUserData } from './profile';
import { normalizeIdea, normalizeTopReaction } from './source';
import { Normalizer } from './types';

export const normalizeKLSource: Normalizer<
  KLArticleApiResponse,
  Source
> = data => {
  return {
    id: data.id,
    ideas: data.blocks.map(idea => normalizeIdea(idea)),
    publishStash: data.stash_published_in
      ? {
          id: data.stash_published_in.id,
          ideaCount: -1,
          emoji: data.stash_published_in.emoji,
          name: data.stash_published_in.name,
        }
      : undefined,
    status: data.status,
    title: data.title,
    sourceType: data.type,
    sourceSubtype: 0,
    suggestedBlocks: [],
    userData: normalizeUserData(data.user_data),
    author: data.author ?? undefined,
    content: undefined,
    description: data.description,
    image: data.image,
    imageColor:
      data.image_color ?? getSourceThemeColor(data.type as SourceType, 'light'),
    imageBlurhash: undefined,
    similarArticles: [],
    topic: [],
    url: data.url,
    suggestedTopics: [],
    context: data.context,
    totalComments: data.total_comments,
    totalReactions: data.total_reactions,
    topReactions: data.top_reactions.map(normalizeTopReaction),
    totalReads: data.total_reads,
  };
};
